import {
  GetMembresiaTrackingClubAlcance,
  PutMembresiaTrackingCompromisos,
  PutMembresiaTrackingAsesores
} from "../../../reducers/comisionMembresia";

export interface TrackingAsesoresStore
  extends GetMembresiaTrackingClubAlcance,
    PutMembresiaTrackingCompromisos,
    PutMembresiaTrackingAsesores {}

export const trackingAsesoresStore: (
  state
) => TrackingAsesoresStore = state => {
  const comisionMembresiaState = state.comisionMembresia;

  return {
    membresiaTrackingClubAlcance:
      comisionMembresiaState.membresiaTrackingClubAlcance,
    gettingMembresiaTrackingClubAlcance:
      comisionMembresiaState.gettingMembresiaTrackingClubAlcance,
    gettingMembresiaTrackingClubAlcanceError:
      comisionMembresiaState.gettingMembresiaTrackingClubAlcanceError,

    putMembresiaTrackingCompromisosResult:
      comisionMembresiaState.putMembresiaTrackingCompromisosResult,
    puttingMembresiaTrackingCompromisos:
      comisionMembresiaState.puttingMembresiaTrackingCompromisos,
    puttingMembresiaTrackingCompromisosError:
      comisionMembresiaState.puttingMembresiaTrackingCompromisosError,

    putMembresiaTrackingAsesoresResult:
      comisionMembresiaState.putMembresiaTrackingAsesoresResult,
    puttingMembresiaTrackingAsesores:
      comisionMembresiaState.puttingMembresiaTrackingAsesores,
    puttingMembresiaTrackingAsesoresError:
      comisionMembresiaState.puttingMembresiaTrackingAsesoresError
  };
};
